import {mkContent} from "../language-content/language-mk";
import {enContent} from "../language-content/language-en";
import {alContent} from "../language-content/language-al";

const TranslationService = {
    translate: (key, lang) => {
        let content = mkContent;
        if(lang === 'en_US') {
            content = enContent;
        } else if (lang === 'sq_AL') {
            content = alContent;
        }

        return content.find(c => c.key === key).value;
    }
};

export default TranslationService;
